import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { GoChevronRight } from "react-icons/go";
import { useAuth } from "../../context/auth";
import './Sidebar.css';
import { useTranslation } from "react-i18next";

function Sidebar({sidebar, sidebarActive, closeSidebar, collapsed}) {
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState({});
  const { can } = useAuth();
  const { t } = useTranslation();

  const toggleExpand = (key) => {
    setExpandedItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const visibleSidebar = (sidebar ?? []).reduce((acc, item) => {
    if (item.childrens) {
      const visibleChildren = item.childrens.filter(
        (child) => !child.permission || can(child.permission)
      );
      if (visibleChildren.length > 0) {
        acc.push({ ...item, childrens: visibleChildren });
      }
      return acc;
    }
    if (!item.permission || can(item.permission)) {
      acc.push(item);
    }
    return acc;
  }, []);

  const mainItems = visibleSidebar.filter((item) => !item.fixedBottom);
  const bottomItems = visibleSidebar.filter((item) => item.fixedBottom);

  const renderItem = (data, key) => {
    if (data.childrens) {
      const titleDisplay = data.titleKey ? t(data.titleKey) : data.title;
      return (
        <div key={key} className={`nav-item sidebar-nav-item has-submenu ${expandedItems[data.link] || location.pathname.includes(data.link) ? "expanded" : ""}`}>
          <button
            className="nav-link sidebar-nav-link"
            onClick={() => toggleExpand(data.link)}
            aria-expanded={!!expandedItems[data.link]}
            title={titleDisplay}
          >
            {data.icon}
            <span>{titleDisplay}</span>
            <GoChevronRight className="nav-arrow" />
          </button>

          <div className="nav-submenu">
            {data.childrens.map((child, ckey) => (
              <div key={ckey} className={`nav-submenu-item ${location.pathname.includes(child.link) ? "active" : ""}`}>
                <Link className="nav-submenu-link" to={child.link}>
                  {child.titleKey ? t(child.titleKey) : child.title}
                </Link>
              </div>
            ))}
          </div>
        </div>
      );
    } else {
      const titleDisplay = data.titleKey ? t(data.titleKey) : data.title;
      return (
        <div key={key} className={`nav-item sidebar-nav-item ${location.pathname === data.link ? "active" : ""}`}>
          <Link className="nav-link sidebar-nav-link" to={data.link} title={titleDisplay}>
            {data.icon}
            <span>{titleDisplay}</span>
          </Link>
        </div>
      );
    }
  };

  return(
    <>
      <div className={`sidebar-overlay ${sidebarActive ? "active" : ""}`} onClick={closeSidebar}></div>

      <aside className={`sidebar ${sidebarActive ? "active" : ""} ${collapsed ? "collapsed" : ""}`} id="sidebar">
        <nav className="nav-menu">
          {mainItems.map((data, key) => renderItem(data, key))}
        </nav>
        {bottomItems.length > 0 && (
          <nav className="nav-menu nav-menu-bottom">
            {bottomItems.map((data, key) => renderItem(data, key))}
          </nav>
        )}
      </aside>
    </>
  );
}

export default Sidebar;